<template>
  <div class="attendance-confirmation">
    <v-card-title class="headline">Attendance Summary</v-card-title>
    <v-card-text>
      <div class="confirmation-summary">
        <span class="present-count">{{ data.presentCount }} Present</span>,
        <span class="absent-count">{{ data.absentCount }} Absent</span>
        out of <strong>{{ data.totalCount }}</strong> students
      </div>

      <v-expansion-panels
        v-if="data.absentStudents && data.absentStudents.length"
        class="mt-4"
        flat
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            Absent Students ({{ data.absentStudents.length }})
            <span class="click-hint">— click to view</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-for="(student, idx) in data.absentStudents"
              :key="idx"
              class="absent-student-item"
            >
              <span>{{ idx + 1 }}. {{ student.name }}</span>
              <span v-if="student.roll_number" class="roll-number">
                (Roll No.: {{ student.roll_number }})
              </span>
              <span v-else class="roll-number">
                (Student ID: {{ student.student_id }})
              </span>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onCancel">Cancel</v-btn>
      <v-btn color="primary" class="cust-btn" @click="onConfirm">Submit</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  name: "AttendanceConfirmation",
  props: ["data", "onClose"],
  methods: {
    onCancel() {
      this.onClose({ status: false, action: "cancel" });
    },
    onConfirm() {
      this.onClose({ status: false, action: "confirm" });
    },
  },
};
</script>
<style scoped>
.attendance-confirmation {
  padding: 8px;
}
.confirmation-summary {
  font-size: 16px;
  margin-top: 8px;
}
.present-count {
  color: #4caf50;
  font-weight: 600;
}
.absent-count {
  color: #f44336;
  font-weight: 600;
}
.absent-student-item {
  padding: 4px 0;
  font-size: 14px;
}
.roll-number {
  color: #888;
  margin-left: 4px;
}
.click-hint {
  font-size: 12px;
  color: #999;
  margin-right: 4px;
}
</style>
